module.exports = __webpack_public_path__ + "static/img/service-h5-2.00003c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/service-h5-2.png
// module id = GxSO
// module chunks = 34